<template>
  <a-modal name="task-on-moderation">
    <div  class="task-on-moderation" @click.self="closeModal">
      <div class="bg-color" @click.self="closeModal"></div>
      <div class="task-on-moderation-modal">
        <h2 class="task-on-moderation-modal__title">
          Ваше задание на модерации
        </h2>
        <p class="task-on-moderation-modal__text">
          После прохождения модерации оно станет доступным для волонтеров
        </p>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {AModal, useAModal} from "../ui";
export default {
  name: "TaskOnModeration",
  components: {
    AModal,
    useAModal
  },
  setup(props) {
    const modal = useAModal()
    const closeModal = () => {
      modal.hide();
    }

    return {
      closeModal
    };
  }
}
</script>

<style scoped lang="scss">
  .bg-color {
    width: 100%;
    height: 50vh;
    background: #6367A7;
  }
  .task-on-moderation {
    min-height: 100vh;
    background-color: #fff;
  }
  .task-on-moderation-background{
    position: absolute;
    display: block;
    width: 100%;
    height: auto;
    pointer-events: none;
  }
  .task-on-moderation-modal{
    position: absolute;
    max-width: 684px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 45px 64px 60px 57px;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
  @include mobile{
    padding: 20px;
  }
  &__title{
     margin: 0 0 36px;
    font-size: 39px;
   }
    &__text{
      font-size: 14px;
      line-height: 20px;
      color: #161515;
      margin-bottom: 12px;
    }
  }
</style>